<!--
 * @Author: scg
 * @Date: 2022-01-17 16:18:42
 * @LastEditTime: 2022-02-28 09:40:30
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div id="login">
    <div class="login_logo">
      <div class="img">
        <img src="@/assets/img/logosvg.svg" />
      </div>
      <div class="title">Sign in or create an account</div>
    </div>
    <div class="login">
      <div class="language">
         <languageTranslation></languageTranslation>
        <!-- <div class="flag">
          <img src="@/assets/img/flag.png" />
        </div>
        <div class="dow">
          <img src="@/assets/img/dow.png" />
        </div> -->
      </div>
      <div id="login_lo">
        <div class="title2">Forgot Password?</div>
        <div class="ftitle">
          Enter your email address below and we will send a verification code to you.
        </div>
      </div>
      <div class="login_input">
        <div class="login_input_title">Email</div>
        <input autocomplete="off" v-model="logins.email" placeholder="Enter your email" />
        <div class="Tips">
          {{ msg }}
        </div>
      </div>
      <div @click="foem" class="loginButton">Send Me Code</div>
      <router-link :to="{ name: 'login' }" class="login_a router-link-active"
        >Back to Sign in</router-link
      >
    </div>
  </div>
</template>

<script>
import { apiEmssend } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      code: false,
      logins: {
        email: '',
        event: 'resetpwd'
      }
    }
  },
  mounted () {
  },
  methods: {
    foem () {
      apiEmssend(this.logins).then((adj) => {
        console.log(adj)
        // this.code = adj.code === 0
        this.msg = adj.code === 0 ? adj.msg : ''
        if (adj.code === 1) {
          this.$router.push({
            name: '/password',
            query: { email: this.logins.email }
          })
          localStorage.setItem('username', this.logins.email)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: url(./../assets/img/login.png);
  background-size: 100% auto;
  color: #fff;
}
.login_logo {
  position: absolute;
  top: 45%;
  right: 70%;
}
.login_logo .img,
.login_logo .img img {
  width: 170px;
}
.login_logo .title {
  font-size: 16px;
  line-height: 50px;
}
.login {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -300px 0 0;
  background: #fff;
  border-radius: 20px;
}
.login .language {
  position: absolute;
  right: 20px;
  top: 20px;
  /* width: 40px; */
  /* height: 20px; */
  overflow: hidden;
}
.login .language .flag {
  border-radius: 8px;
}
.login .language .dow,
.login .language .flag {
  width: 16px;
  height: 16px;
  overflow: hidden;
  float: left;
  position: relative;
  margin: 2px;
}
.login .language img {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  left: 0;
}
#login_lo {
  width: 360px;
  margin: 0 auto;
  color: #000;
  text-align: left;
}
#login_lo .title {
  font-size: 32px;
  font-weight: 700;
  font-family: Noto Sans;
  margin: 60px 0 30px;
}
#login_lo .title2 {
  font-size: 24px;
  font-weight: 700;
  font-family: Noto Sans;
  line-height: 36px;
  margin: 60px 0 30px;
}
#login_lo .ftitle {
  font-size: 13px;
  font-family: Noto Sans;
  line-height: 20px;
  color: #9f9f9f;
  margin-bottom: 20px;
}
.login_input {
  width: 360px;
  margin: 0 auto;
  padding-bottom: 10px;
  text-align: left;
  position: relative;
}
.login_input .login_input_title {
  font-size: 14px;
  line-height: 30px;
  color: #000;
}
.login_input input {
  height: 48px;
  width: 358px;
  border-radius: 8px;
  border: 1px solid #d5d7db;
  text-indent: 1em;
  font-size: 14px;
  padding: 0;
}
.login_input input:focus {
  border: 1px solid #00eec3;
}
.login_input input.error {
  border: 1px solid #f54545;
}
.login_input_eye {
  position: absolute;
  bottom: 10px;
  right: 16px;
  width: 16px;
  height: 16px;
  bottom: 28px;
}
.loginButton {
  width: 360px;
  height: 50px;
  border-radius: 25px;
  background: #00eec3;
  font-size: 16px;
  font-weight: 700;
  color: #000927;
  line-height: 50px;
  margin: 90px auto 50px;
  -webkit-box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  user-select: none;
}
.Tips {
  width: 360px;
  height: 16px;
  text-align: left;
  color: #f54545;
  font-size: 12px;
  margin: 10px auto 10px;
}
.login_a {
  font-size: 14px;
  text-align: center;
  color: #0080ff;
  display: block;
  margin-bottom: 30px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Forgot.vue